//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        score: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'large'
        }
    },
    computed: {
        default_icon () {
            return `https://cdn.vip-wifi.com/fangchan/img/building/plates/${this.type === 'large' ? 'big-star' : 'star'}.png`
        },
        active_icon () {
            return `https://cdn.vip-wifi.com/fangchan/img/building/plates/${this.type === 'large' ? 'big-star-active' : 'star-active'}.png`
        },
        percent () {
            return this.score / 5 * 100 + '%'
        }
    }
}
